$(function () {
  'use strict';

  var $cards_sliders = $('.js-app-cards-slider');

  // Early exit
  if(!$cards_sliders.length) return;

  var $window = $(window);

  var unmount = function ($items) {
    $items.slick("destroy");

    return false;
  };

  var mount = function ($items) {
    $items.slick({
      dots: true,
      infinite: false,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 4000,
      variableWidth: true
    });

    return true;
  };

  $cards_sliders.each(function(index, cards_slider) {
    var $cards_slider = $(cards_slider);
    var $items = $cards_slider.find('.js-app-cards-slider-items');
    var state = false;
    var has_resized = false;

    var update = function () {
      if(has_resized) {
        if($items.css("overflow") == "hidden" && state) { // Slider no need to be active
          state = unmount($items);
        } else if($items.css("overflow") != "hidden" && !state) { // Slider need to be active
          state = mount($items);
        }
      }

      /*pour utilisation en carousel basique*/
      if($items.hasClass( "carousel")) {

          state = mount($items);
      }

      has_resized = false;
      window.requestAnimationFrame(update);
    };

    $window.on('resize', function() {
      has_resized = true;
    });


    if(!window.matchMedia("(min-width: 980px)").matches) {
      state = mount($items);
    }

    window.requestAnimationFrame(update);
  });

});
